import { useState } from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/sales-return/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import SalesReturnModal from "./SalesReturnModal"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import {
  SalesReturnCrudProvider,
  useSalesReturnCrudContext,
} from "@/context/salesReturnCrudContext"
import { useNavigate } from "react-router-dom"

export default function SalesReturnList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Sales Return</h5>
      </div>

      <SalesReturnCrudProvider>
        <SalesReturnTable />
      </SalesReturnCrudProvider>
    </>
  )
}

function SalesReturnTable() {
  const {
    openSalesReturnDialog,
    setOpenSalesReturnDialog,
    setSelectedSalesReturnRow,
  } = useSalesReturnCrudContext()

  const navigate = useNavigate()

  return (
    <>
      <CustomTable
        label="Sales Return"
        columns={columns}
        apiPath="sales-return"
        onAdd={() => setOpenSalesReturnDialog(true)}
        onView={(rowData) => {
          navigate(`/sales/${rowData.order_id}`)
        }}
        showEdit={false}
        showDelete={false}
      />

      {openSalesReturnDialog ? <SalesReturnModal /> : null}
    </>
  )
}
